import { AppContainer } from './App.container';
import { AppRoutes } from './Routes';
import { allRoutes } from './allRoutes';

export type PublicProps = {
  children?: React.ReactNode;
  callbacks: {};
};

export const Public = (props: PublicProps) => {
  return (
    <AppRoutes routes={allRoutes} isPublic>
      <AppContainer />
    </AppRoutes>
  );
};
